import React, { type ReactNode } from 'react';

export function ActiveColumnCell({ active }: { active: boolean | undefined }): ReactNode {
	return (
		<span
			className={`inline-flex items-center rounded-md px-2.5 py-1 text-xs font-medium ${
				active ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'
			}`}
		>
			{active ? 'Active' : 'Inactive'}
		</span>
	);
}
